import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2, Plus, X } from "lucide-react";
import { api, fileUrl, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const EMPTY = { title: "", event: "", year: new Date().getFullYear(), description: "" };

export const AdminAwards = () => {
  const [awards, setAwards] = useState([]);
  const [f, setF] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [image, setImage] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/awards").then((r) => setAwards(r.data));
  useEffect(() => { load(); }, []);
  const reset = (form) => { setF(EMPTY); setEditing(null); setImage(null); form?.reset(); };

  const submit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    Object.entries(f).forEach(([k, v]) => fd.append(k, v));
    if (image) fd.append("image", image);
    setBusy(true);
    try {
      editing ? await api.put(`/admin/awards/${editing}`, fd) : await api.post("/admin/awards", fd);
      toast.success(editing ? "Premio actualizado" : "Premio agregado");
      reset(e.target);
      load();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const edit = (a) => { setEditing(a.id); setF({ title: a.title, event: a.event, year: a.year, description: a.description }); window.scrollTo({ top: 0, behavior: "smooth" }); };
  const remove = async (id) => { if (!window.confirm("¿Eliminar este premio?")) return; await api.delete(`/admin/awards/${id}`); toast.success("Eliminado"); load(); };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  return (
    <div className="grid gap-6 lg:grid-cols-12" data-testid="admin-awards">
      <form onSubmit={submit} className="card-fv p-6 space-y-4 lg:col-span-5 h-fit">
        <p className="f-display text-xl">{editing ? "Editar premio" : "Nuevo premio"}</p>
        <div className="space-y-2"><Label>Distinción</Label><Input required value={f.title} onChange={set("title")} placeholder="Gran Campeón Macho" data-testid="admin-award-title-input" /></div>
        <div className="space-y-2"><Label>Exposición / evento</Label><Input value={f.event} onChange={set("event")} data-testid="admin-award-event-input" /></div>
        <div className="space-y-2"><Label>Año</Label><Input required type="number" value={f.year} onChange={set("year")} data-testid="admin-award-year-input" /></div>
        <div className="space-y-2"><Label>Descripción</Label><Textarea rows={3} value={f.description} onChange={set("description")} data-testid="admin-award-description-input" /></div>
        <div className="space-y-2"><Label>Foto</Label><Input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} data-testid="admin-award-image-input" /></div>
        <div className="flex gap-2">
          <button disabled={busy} className="btn-fv btn-red !py-2.5 disabled:opacity-60" data-testid="admin-award-save-button"><Plus size={16} />{editing ? "Guardar cambios" : "Agregar"}</button>
          {editing && <button type="button" onClick={(e) => reset(e.target.form)} className="btn-fv btn-outline !py-2.5" data-testid="admin-award-cancel-button"><X size={16} />Cancelar</button>}
        </div>
      </form>
      <ul className="lg:col-span-7 space-y-3">
        {awards.map((a) => (
          <li key={a.id} className="card-fv flex items-center gap-4 p-4" data-testid={`admin-award-item-${a.id}`}>
            {a.image_url ? <img src={fileUrl(a.image_url)} alt="" className="h-16 w-24 object-cover" /> : <div className="h-16 w-24 bg-[#F3EAD7]" />}
            <div className="flex-1 min-w-0">
              <p className="font-semibold">{a.year} · {a.title}</p>
              <p className="text-sm text-[#5C635E] truncate">{a.event}</p>
            </div>
            <button onClick={() => edit(a)} className="p-2 hover:bg-stone-100" data-testid={`admin-award-edit-${a.id}`} aria-label="Editar"><Pencil size={16} /></button>
            <button onClick={() => remove(a.id)} className="p-2 text-red-700 hover:bg-red-50" data-testid={`admin-award-delete-${a.id}`} aria-label="Eliminar"><Trash2 size={16} /></button>
          </li>
        ))}
        {awards.length === 0 && <li className="text-[#5C635E]">No hay premios cargados.</li>}
      </ul>
    </div>
  );
};
